<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PME03A/images/e9781439632802_cover.jpg?1688985071032" alt="This image is the cover for the book Sterling Township, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sterling Township, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p>Sterling Township, located about 18 miles northeast of Detroit, was first settled after the Erie Canal was opened. The rich soil, relatively flat land, and the vital Clinton River attracted pioneer and immigrant families who arrived to establish farmsteads. The first influx of immigrants came mainly from the British Isles, and by the 1870s, German<br/>families had flocked to the area, raising dairy cattle and<br/>establishing farms. Belgians, arriving in the early 1900s,<br/>developed truck farming�growing fruits and vegetables<br/>to sell every week at the farmers� market in Detroit. Farm<br/>culture prevailed until the 1950s, when large industrial<br/>plants began moving in, bringing with them workers and<br/>a need for housing and city services. Sterling Township<br/>became the city of Sterling Heights in 1968, and this<br/>collection of photographs will showcase the families and<br/>the way of life in the early days of this community, a<br/>historic community that is now the fourth largest city in Michigan.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sterling Township Public Library, Historical Commission
      </h2>
      
      <p class="authorDescription body article">Debra Vercellone is a librarian and local history authority for the Sterling Heights Public Library. A lifelong resident of the Sterling Heights area, she has had a keen interest in local history since childhood, when her father pointed out an abandoned one-room schoolhouse. She has degrees in history and in library science from the University of Michigan. Wallace Doebler�s family has deep roots in Sterling Township. Doebler has been very active in civic and business affairs, serving on the Sterling Heights Historical Commission for many years. He has written three books on local history.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?87cd434a